import styled from "styled-components";

import IconButton from "@/components/Atoms/Button/IconButton";

import theme from "../../../foundation/Theme";

export const ActionButton = styled(IconButton)`
  justify-content: space-between;
  align-items: center;
  padding: 0;

  @keyframes like {
    0% {
      transform: scale(1);
    }
    90% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }

  svg {
    &.active {
      animation: like 0.5s 1;
      fill: ${theme.colorsV2.shyft.purple_text};
      path {
        stroke: ${theme.colorsV2.shyft.purple_text};
      }
    }
  }
`;
